import React, { useEffect, useState } from 'react';
import { fastapi } from '../../services/api';

const AdminBillingPage: React.FC = () => {
  const [costs, setCosts] = useState<any[]>([]);

  useEffect(() => {
    fetchCosts();
  }, []);

  const fetchCosts = async () => {
    try {
      const res = await fastapi.get('/admin/billing/costs');
      setCosts(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="p-8 space-y-6">
      <h1 className="text-3xl font-bold text-white/90">Platform Billing & Bot Costs</h1>
      <div className="bg-white/5 border border-white/10 rounded-2xl backdrop-blur-xl overflow-hidden">
        <table className="w-full text-left text-sm text-white/80">
          <thead className="bg-white/10 text-white/60 uppercase">
            <tr>
              <th className="px-6 py-4">ID</th>
              <th className="px-6 py-4">Comercio</th>
              <th className="px-6 py-4">Tokens Used</th>
              <th className="px-6 py-4">Cost (USD)</th>
              <th className="px-6 py-4">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/10">
            {costs.map((c) => (
              <tr key={c.id} className="hover:bg-white/5 transition-colors">
                <td className="px-6 py-4">{c.id}</td>
                <td className="px-6 py-4 font-medium">{c.comercio_key}</td>
                <td className="px-6 py-4">{c.tokens_used}</td>
                <td className="px-6 py-4">${(c.cost_usd || 0).toFixed(6)}</td>
                <td className="px-6 py-4">{new Date(c.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {costs.length === 0 && (
              <tr>
                <td colSpan={5} className="px-6 py-8 text-center text-white/50">
                  No bot usage recorded yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminBillingPage;
